/** Client-side helpers aligned with backend (220 wpm). */

export function stripHtml(html) {
    return String(html || "")
        .replace(/<[^>]+>/g, " ")
        .replace(/\s+/g, " ")
        .trim();
}

export function estimateReadingMinutes(html, wordsPerMinute = 220) {
    const text = stripHtml(html);
    const words = text.split(/\s+/).filter(Boolean).length;
    return Math.max(1, Math.ceil(words / wordsPerMinute));
}

/** Prefer stored `readingTimeMinutes`; otherwise estimate from HTML content. */
export function readingTimeLabelFromBlog(blog) {
    const stored = blog?.readingTimeMinutes;
    if (typeof stored === "number" && Number.isFinite(stored) && stored >= 1) {
        return `${Math.round(stored)} min read`;
    }
    return `${estimateReadingMinutes(blog?.content)} min read`;
}
